/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weeks: NonNullable<unknown> }} Today_Streak_LabelInputs */

const en_us2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 week in a row. View in profile`);
	return /** @type {LocalizedString} */ (`${i?.weeks} weeks in a row. View in profile`)
	
};

const pt_br2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. Ver no perfil`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Ver no perfil`)
	
};

const es_419_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. Ver en el perfil`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Ver en el perfil`)
	
};

const pt_pt2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semana seguida. Ver no perfil`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semanas seguidas. Ver no perfil`)
	
};

const fr_fr2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 semaine d'affilée. Voir dans le profil`);
	return /** @type {LocalizedString} */ (`${i?.weeks} semaines d'affilée. Voir dans le profil`)
	
};

const de_de2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 Woche am Stück. Im Profil ansehen`);
	return /** @type {LocalizedString} */ (`${i?.weeks} Wochen am Stück. Im Profil ansehen`)
	
};

const it_it2_today_streak_label = /** @type {(inputs: Today_Streak_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.weeks === 1 || i?.weeks === "1")) return /** @type {LocalizedString} */ (`1 settimana di fila. Vedi nel profilo`);
	return /** @type {LocalizedString} */ (`${i?.weeks} settimane di fila. Vedi nel profilo`)
	
};

/**
* | weeks | output |
* | --- | --- |
* | "1" | "1 week in a row. View in profile" |
* | * | "{weeks} weeks in a row. View in profile" |
*
* @param {Today_Streak_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_streak_label = /** @type {((inputs: Today_Streak_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Streak_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_streak_label(inputs)
	if (locale === "es-419") return es_419_today_streak_label(inputs)
	if (locale === "pt-PT") return pt_pt2_today_streak_label(inputs)
	if (locale === "fr-FR") return fr_fr2_today_streak_label(inputs)
	if (locale === "de-DE") return de_de2_today_streak_label(inputs)
	if (locale === "it-IT") return it_it2_today_streak_label(inputs)
	return en_us2_today_streak_label(inputs)
});
export { today_streak_label as "today.streak_label" }